import {
    onAllClick,
    scrollToElement,
    isAdmin,
} from "kwp-core/scripts/utils/helpers";

export default () => {
    // auto-scrolling
    // if (window.location.hash) {
    //     history.scrollRestoration = "manual";
    //     const target = document.querySelector(window.location.hash);
    //     scrollToElement(target);
    // }
    // // else if (history.scrollRestoration != "manual") {
    // //     history.scrollRestoration = "auto";
    // // }
    // onAllClick('[href^="#"]', (e) => {
    //     if (!isAdmin()) {
    //         e.preventDefault();
    //         e.stopPropagation();
    //         try {
    //             const hash = e.currentTarget.hash;
    //             let target = document.querySelector(hash);
    //             scrollToElement(target);
    //         } catch (e) {
    //             console.log("smooth scroll error");
    //         }
    //     }
    // });
};
